import axios from '../axios';

const path = '/api/login';
export default {
  login(body) {
    return axios.post(path, body);
  },
};
